/**
 * Data cardinality values
 */
export enum DataCardinalityEnum {
	SINGLE_RECORD = 'single_record',
	LIST = 'list',
}
